import { useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '@/contexts/AuthContext';
import { useTheme } from '@/contexts/ThemeContext';
import { API_BASE } from '@/utils/api';

// Trae del servidor la apariencia del usuario (la sigue en cualquier dispositivo)
export const AppearanceSync = () => {
  const { user } = useAuth();
  const { hydrate } = useTheme();
  const key = user ? `${user.user_id}:${user.active_business_id || user.business_id || ''}` : null;
  useEffect(() => {
    if (!key) {
      hydrate(null);
      return;
    }
    axios.get(`${API_BASE}/appearance/me`).then(r => hydrate(r.data)).catch(() => {});
  }, [key, hydrate]);
  return null;
};
